export const SAVING_BUTTON_DELAY = 1000;
export const MAX_SAVING_PROGRESS = 80;
export const MAX_SAVED_PROGRESS = 100;
